export default {
  messages: {
    parseOrderFailed: 'Failed to parse order result',
    wsConnectFailed: 'Failed to connect WebSocket',
    accountInfoIncomplete: 'Account info incomplete, cannot establish WebSocket connection',
    websocketNotConnected: 'WebSocket not connected',
    websocketClosed: 'WebSocket connection closed',
    requestTimeout: 'Request timeout',
    requestFailed: 'Request failed',
  },
  common: {
    loss: 'Loss',
    profit: 'Profit',
    lots: 'Lots',
    pips: 'Pips',
    actions: 'Actions',
    unknown: 'Unknown',
    socket: {
      connection: {
        failed: 'WebSocket connection failed',
        retry: 'Attempting to reconnect, please wait...',
      },
    },
  },
  // new
  form: {
    message: {
      marketClosed: 'Market is closed during this period',
      marketClosedTooltip: 'Market is closed.',
      insufficientFunds:
        'Your available funds are insufficient for this trade. Please add additional funds to your account to complete the transaction.',
      volumeRange: 'Volume range: {min}-{max}',
      symbolNotFound: 'Symbol not found',
      pleaseEnterTransactionPrice: 'Please enter the transaction price',
      pleaseEnterTakeProfitPrice: 'Please enter the take profit price',
      pleaseEnterStopLossPrice: 'Please enter the stop loss price',
      priceSameAsCurrent: 'Price is the same as the current price',
    },
    label: {
      lots: 'Lots',
      contractSize: 'Contract Size',
      pipValue: 'Pip Value',
      swap: 'Swap',
      leverage: 'Leverage',
      pendingOrder: 'Pending Order',
      takeProfit: 'Take Profit',
      stopLoss: 'Stop Loss',
      priceUnit: 'Price',
      pipsUnit: 'Pips',
      sell: 'Sell',
      buy: 'Buy',
      confirm: 'Confirm',
      confirmBuy: 'Confirm Buy',
      confirmSell: 'Confirm Sell',
    },
    placeholder: {
      volume: 'Enter volume',
      pendingPrice: 'Enter pending price',
      takeProfit: 'Enter take-profit',
      stopLoss: 'Enter stop-loss',
    },
    tooltip: {
      pendingOrder: 'Place an order to execute at a specific price',
      takeProfit: 'Set a price to automatically close with profit',
      stopLoss: 'Set a price to automatically close to limit loss',
    },
    text: {
      pending: {
        label: 'Pending',
        desc: 'Your order will be triggered automatically once the market price matches the specified value',
      },
      take: {
        label: 'Take Profit',
        desc: 'By setting a Take Profit, your order will automatically close at the specified price, helping you lock in profits',
      },
      stop: {
        label: 'Stop Loss',
        desc: 'By setting a Stop Loss, your order will automatically close at your specified price to minimize losses.',
      },
      sell: 'SELL',
      buy: 'BUY',
      confirm: 'Confirm',
    },
    title: {
      volume: 'Close Volume',
    },
  },
  error: {
    volumeRange: 'Volume must be between {min} and {max}',
    volumeStep: 'Volume must be a multiple of {step}',
    priceTick: 'Price must be aligned with tick size {tick}',
    priceDistance: 'Price must be at least {dist} away',
    pendingPriceDirection: 'Invalid price direction for pending order',
    takeProfitDirection:
      'Take-profit price must be above reference price for buy or below for sell',
    stopLossDirection: 'Stop-loss price must be below reference price for buy or above for sell',
    symbolPicker: {
      exceedMaxLimit: 'The number of symbols opened at the same time cannot exceed {limit}',
      failed: 'Failed to select, please try again',
    },
  },
  slTpUnit: {
    PRICE: 'Price',
    PIPS: 'Pips',
    MONEY: 'Money',
    EQUITY_PERCENT: 'Equity Percent',
  },
  table: {
    symbol: 'Symbol',
    order_type: 'Order Type',
    volume: 'Volume',
    open_price: 'Open Price',
    current_price: 'Current Price',
    take_profit: 'Take Profit',
    stop_loss: 'Stop Loss',
    open_time: 'Open Time',
    swap: 'Swap',
    profit_loss: 'Profit/Loss',
    order_id: 'Order ID',
    close_price: 'Close Price',
    close_time: 'Close Time',
    commission: 'Commission',
    direction: 'Direction',
    add: 'Add',
    close: 'Close',
    pending: {
      current_price: 'Current Price',
      open_price: 'Open Price',
      open_time: 'Open Time',
      delete: 'Close',
      update: 'Update',
      actions: {
        update: {
          info: {
            message: 'Order sent',
          },
          success: {
            message: 'Updated',
          },
          error: {
            message: 'Failed',
          },
        },
        delete: {
          info: {
            message: 'Order sent',
          },
          success: {
            message: 'Deleted',
          },
          error: {
            message: 'Failed',
          },
        },
      },
    },
  },
  search: {
    table: {
      symbol: 'Symbol',
      bid: 'Sell Price',
      ask: 'Buy Price',
      feed: 'Market Sentiment',
      change: 'Price Change',
      market_closed: 'Market Closed',
      feed_details: 'Feed Details',
    },
  },
  tab: {
    open_orders: 'Open Orders',
    pending_orders: 'Pending Orders',
    closed_orders: 'Closed Orders',
  },
  'nav-tabs': {
    modal: {
      title: 'Select Instrument',
      ok: 'OK',
      cancel: 'Cancel',
    },
  },
  order: {
    notification: {
      open: {
        info: {
          message: 'Order sent',
        },
        success: {
          message: 'Opened',
        },
        error: {
          message: 'Failed',
          desc: 'Failed to submit open order instruction',
        },
      },
      'open-limit': {
        info: {
          message: 'Order sent',
        },
        success: {
          message: 'Order placed',
        },
        error: {
          message: 'Order failed',
          desc: 'Failed to submit open limit order instruction',
        },
      },
      close: {
        info: {
          message: 'Closing',
        },
        success: {
          message: 'Closed',
        },
        error: {
          message: 'Failed',
        },
      },
      update: {
        info: {
          message: 'Updating',
        },
        success: {
          message: 'Updated',
        },
        error: {
          message: 'Failed',
        },
      },
    },
    type: {
      buy: 'Buy',
      sell: 'Sell',
      hedged: 'Hedged',
      'buy-limit': 'Buy Limit',
      'sell-limit': 'Sell Limit',
      'buy-stop': 'Buy Stop',
      'sell-stop': 'Sell Stop',
    },
    form: {
      takeProfit: {
        label: 'Take Profit',
        description:
          'When a Take Profit is set, the order will automatically close at the specified price to lock in profits.',
      },
      stopLoss: {
        label: 'Stop Loss',
        description:
          'When a Stop Loss is set, the order will automatically close at the specified price to limit losses.',
      },
      closeVolume: {
        label: 'Close Volume',
        range: 'Valid range: {min} - {max}',
      },
      placeholder: {
        number: 'Enter a value',
      },
      unit: {
        price: 'Price',
        pips: 'Pips',
      },
      text: {
        take: {
          label: 'Take Profit',
          desc: 'By setting a Take Profit, your order will automatically close at the specified price, helping you lock in profits',
        },
        stop: {
          label: 'Stop Loss',
          desc: 'By setting a Stop Loss, your order will automatically close at your specified price to minimize losses.',
        },
      },
    },
    update: {
      tab: {
        takeProfitStopLoss: 'Take Profit/Stop Loss',
        partialClose: 'Partial Close',
      },
      button: {
        submit: 'Confirm Changes',
        partialClose: 'Confirm Close',
      },
      modal: {
        tab: {
          sltp: 'Update SL/TP',
          close: 'Partial Close',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
        title: {
          open: 'Update Open Order',
          pending: 'Update Pending Order',
        },
      },
      'pending-modal': {
        'open-price': 'Open Price',
        'open-price-tip-min': 'Min: {min}',
        'open-price-tip-max': 'Max: {max}',
      },
    },
    error: {
      invalidInput: 'Invalid Input',
      takeProfitPositive: 'Take Profit must be a positive number',
      stopLossPositive: 'Stop Loss must be a positive number',
      closeVolumeRequired: 'Please enter a valid close volume',
      closeVolumeRange: 'Close volume must be between {min} and {max}',
    },
    'type-with-price': '{type} at {price}',
    buy: 'Buy',
    sell: 'Sell',
    'current-symbol-open-orders': 'Only show current symbol orders',
    close: {
      popconfirm: {
        title: 'You are about to close the order, do you want to continue?',
        desc: "Don't remind me next time",
        'ok-button-text': 'Yes, Close',
        'cancel-button-text': 'Cancel',
      },
      info: {
        message: 'Closing order',
        desc: 'Submitting close order instruction...',
      },
      error: {
        message: 'Failed to close order',
        desc: 'Failed to submit close order instruction',
      },
      success: {
        message: 'Closed',
        desc: 'Close order instruction submitted successfully',
      },
      modal: {
        title: 'Close Order',
        desc: 'You are about to close the order. Do you want to proceed?',
        'checkbox-label': "Don't remind me again",
        cancel: 'Go back',
        ok: 'Yes, Close the order',
      },
    },
    'close-dropdown': {
      'close-all': 'Close All',
      'close-all-confirm': 'Close all positions at market price?',
      'select-symbols': 'Select Trading Symbols',
      'select-category': 'Select Close Category',
      'check-all': 'Check All',
      all: 'Close All',
      profitable: 'Close All Profitable Positions',
      losing: 'Close All Losing Positions',
      buy: 'Close All Long Positions',
      sell: 'Close All Short Positions',
      cancel: 'Cancel',
      continue: 'Continue',
    },
  },
  account: {
    equity: 'Account Equity',
    'free-margin': 'Free Margin',
    balance: 'Account Balance',
    margin: 'Margin',
    credit: 'Credit',
    'margin-level': 'Margin Level',
    'profit-loss': 'Total Profit/Loss',
  },
  chart: {
    'buy-small-button-text': 'Buy',
    'sell-small-button-text': 'Sell',
    tab: {
      chart: 'Chart',
      'contract-detail': 'Contract Details',
    },
    'contract-detail': {
      // Titles
      transaction: 'Transaction',
      time: 'Time',
      quote: 'Quote',
      trade: 'Trade',

      // Trading Properties
      spread: 'Spread',
      'spread-type': 'Floating',
      'decimal-position': 'Decimal Position',
      'stop-loss-level': 'Stop Level',
      'contract-size-per-hand': 'Contract Size Per Lot',
      'margin-currency': 'Margin Currency',
      'profit-calculation-mode': 'Profit Calculation Mode',
      'margin-calculation-mode': 'Margin Calculation Mode',
      'calculation-mode-forex': 'Forex',
      'hedge-margin': 'Hedge Margin',
      'hedge-margin-value': '100%',
      'trade-mode': 'Trade Mode',
      'trade-mode-secure': 'Secure Access',
      execution: 'Execution',
      'execution-type': 'Market',
      'gtc-mode': 'GTC Mode',
      'gtc-mode-description': 'Good Till Cancelled',
      'minimum-trade-volume': 'Minimum Trade Volume',
      'maximum-trade-volume': 'Maximum Trade Volume',

      // Status
      'no-data': 'No Data',
      'no-quote': 'No Quote',
      'not-tradable': 'Not Tradable',
    },
  },
  panel: {
    marketClosedPanel: {
      title: 'The market will start the auction after the countdown',
      openTime: 'Open Time',
      openTimeDesc: 'Open Time',
    },
    'market-closed': 'Market Closed',
    'buy-long': 'Buy/Long',
    'sell-short': 'Sell/Short',
    'order-type': {
      market: 'Market Order',
      limit: 'Limit Order',
    },
    lots: 'Lots',
    input: {
      'please-input': 'Please input',
    },
    'stop-loss': 'Stop Loss',
    'take-profit': 'Take Profit',
    'away-from-market-price{value}pips': 'Away from market price {value} pips',
    'sltp-price': 'By Price',
    'sltp-pips': 'By Pips',
    account: {
      'available-margin': 'Available Margin',
      'estimated-occupancy': 'Estimated Occupancy',
      'max-tradable': 'Maximum Tradable',
      leverage: 'Leverage',
      'swap-long': 'Buy Interest',
      'swap-short': 'Sell Interest',
      currency: 'USD',
    },
  },
  placeholder: {
    'not-set': 'Not set',
  },
  'network-status': {
    'status-texts': {
      '0': 'No Signal',
      '1': 'Very Weak',
      '2': 'Weak',
      '3': 'Good',
      '4': 'Excellent',
    },
    'alert-messages': {
      '0': 'Offline!',
      '1': 'Signal Lost!',
      '2': 'Signal Weak!',
    },
  },
}
